import React, { useState } from 'react';

import { AuthorizedApolloProvider } from '../../AuthorizedApolloProvider/AuthorizedApolloProvider';
import { AppLayout } from '../AppLayout/AppLayout';
import { Content } from '../Content/Content';
import { Header } from '../Header/Header';
import { Sidebar } from '../Sidebar/Sidebar';

export const Layout: React.FunctionComponent = ({ children }) => {
  const [sidebarState, setSidebarState] = useState<'' | true | false | 'responsive'>('responsive');

  return (
    <AuthorizedApolloProvider>
      <AppLayout className="c-default-layout">
        <Sidebar
          sidebarState={sidebarState}
          onToggle={setSidebarState}
        />
        <div className="c-wrapper">
          <Header sidebarState={sidebarState} onSidebarToggle={setSidebarState} />
          <Content>
            {children}
          </Content>
        </div>
      </AppLayout>
    </AuthorizedApolloProvider>
  );
};
